import { ElNotification, ElButton } from 'element-plus'
import { h } from 'vue'

let notified = false

/**
 * 检测前端部署更新
 * 构建时通过 vue.config.js 注入 VUE_APP_BUILD_HASH，每次部署生成新 hash
 * 前端定期轮询检测 hash 是否变化，变化则提示用户刷新
 */
export function useUpdateDetector() {
  const currentHash = process.env.VUE_APP_BUILD_HASH || ''

  const checkForUpdates = async () => {
    if (notified || !currentHash) return

    try {
      const res = await fetch('/?t=' + Date.now(), { cache: 'no-cache' })
      const html = await res.text()

      // 从 html 中提取 build-hash meta 标签
      const match = html.match(/name="build-hash" content="([^"]+)"/)
      const onlineHash = match ? match[1] : ''

      if (onlineHash && onlineHash !== currentHash) {
        notified = true
        ElNotification({
          title: '检测到更新',
          message: h('div', { class: 'flex items-center gap-2' }, [
            '应用已发布新版本，请刷新页面以获取最新功能。',
            h(ElButton, {
              type: 'primary',
              size: 'small',
              onClick: () => location.reload()
            }, () => '立即更新')
          ]),
          type: 'success',
          duration: 0,
          onClose: () => { notified = false }
        })
      }
    } catch (e) {
      // ignore
    }
  }

  // 页面加载时立即检测一次
  checkForUpdates()

  // 每 30 秒轮询
  const timer = setInterval(checkForUpdates, 30 * 1000)

  // 组件卸载时清除定时器
  const cleanup = () => clearInterval(timer)

  return { checkForUpdates, cleanup }
}
